// PAQUETERIAS
import { useState, useMemo } from "react";
import Button from "@mui/material/Button";
import dayjs from "dayjs";
import TextField from "@mui/material/TextField";

// COMPONENTES
import MATERIAL_TABLE_CONTAINER from "../../../main_components/material_table/table_container";
import SEARCH_FILTERS from "./tools/shearch_filter";

// ESTILOS
import "../../modal.css";

// IMAGENES
import Motivo from "../../../imgComponents/motivo.png";

// FECHAS
import { formattedCurrentDate, formattedPreviousDate } from "../../../main_components/date/day";

// API
import { pagination_method } from "../../../main_components/pagination/pagination_new_version";

type Option = { value: string; label: string };

type JoinInvoiceProps = {
  type: Option[];       // catálogo de motivos de relación
  rfc: any;
  relacionar?: boolean; // si te sirve para cambiar textos/estilos
  onSubmit: (data: { uuid_sat: string; motivo: string }) => void;
  onClose: () => void;
};

const JOIN_INVOICE: React.FC<JoinInvoiceProps> = (props) => {
  const [data, setData] = useState<any[]>([]);
  const [ff, setff] = useState(dayjs(formattedCurrentDate));
  const [fi, setfi] = useState(dayjs(formattedPreviousDate));
  const [mj, setmj] = useState("");
  const [isLoding, setIsLoding] = useState(false);

  const [select_m, setselect_m] = useState<string>("");
  const [cfdi, setcfdi] = useState(false);        // muestra buscador cuando hay motivo
  const [cfdi_isvalid, setcfdi_isvalid] = useState(false); // ya se seleccionó un uuid
  const [uuidRelation, setuuidRelation] = useState("");

  const [typeDoc, setTypeDoc] = useState("null");

  const handle_select_m = (event: React.ChangeEvent<HTMLInputElement>) => {
    const v = event.target.value;
    setselect_m(v);
    setcfdi(!!v);
    // si cambian motivo, limpia selección previa
    setuuidRelation("");
    setcfdi_isvalid(false);
  };

  const handleChage = () => {
    // permitir elegir otra factura
    setcfdi(true);
    setcfdi_isvalid(false);
    setuuidRelation("");
  };

  const handleSubmit = async () => {
    setIsLoding(true);
    setData([]);
    setmj("Buscando...");
    try {
      const params = {
        di: dayjs(fi).format("YYYY-MM-DD"),
        df: dayjs(ff).format("YYYY-MM-DD"),
        rfc: props.rfc === "" ? null : props.rfc,
        type: typeDoc === "null" ? null : typeDoc,
        cancel: false,
      };
      const dt = await pagination_method("invoices", params);
      const sorted = (dt ?? []).slice().sort((a: any, b: any) => (a.invoice_date < b.invoice_date ? 1 : -1));
      setData(sorted);
    } catch (err) {
      console.error(err);
      setData([]);
    } finally {
      setIsLoding(false);
    }
  };

  const handleConfirmRelacion = () => {
    if (!uuidRelation || !select_m) return;
    props.onSubmit({ uuid_sat: uuidRelation, motivo: select_m });
  };

  const columns = useMemo(
    () => [
      {
        header: "Relacionar",
        id: "Acciones",
        size: 80,
        Cell: ({ row }: any) => {
          const setRelacion = () => {
            setuuidRelation(row.original.uuid_sat);
            setcfdi_isvalid(true);
            setcfdi(false);
          };
          return (
            <div>
              <img
                alt="Relacionar"
                style={{ width: 30, cursor: "pointer" }}
                src={Motivo}
                onClick={setRelacion}
                title={`Relacionar ${row.original.uuid_sat}`}
              />
            </div>
          );
        },
      },
      { header: "Serie", accessorKey: "serie", id: "seriee", size: 100 },
      { header: "Folio", accessorKey: "folio", size: 130 },
      { header: "UUID_SAT", accessorKey: "uuid_sat", id: "uuid_sat", className: "justify_data", size: 250 },
      {
        header: "Total",
        accessorFn: (d: any) =>
          Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(d.total ?? 0),
        size: 130,
      },
    ],
    []
  );

  return (
    <div>
      {/* Motivo de relación */}
      <div className="selectMR">
        <TextField
          select
          label="Motivo de relación"
          value={select_m}
          sx={{ m: 2, width: "100%" }}
          onChange={handle_select_m}
          size="small"
          InputLabelProps={{ shrink: true }}
          SelectProps={{ native: true }}
        >
          {props.type.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </TextField>
      </div>

      <div className="bp-2">
        <p className="contentMCancel">Motivo de relación: {select_m || "—"}</p>
      </div>

      {/* Resumen de selección y opción para cambiar */}
      <p
        style={{ display: cfdi_isvalid ? "" : "none", cursor: "pointer" }}
        className="contentMCancel"
        title="Seleccionar otra factura"
        onClick={handleChage}
      >
        Factura seleccionada: {uuidRelation} — (click para cambiar)
      </p>

      {/* Bloque de búsqueda (solo si hay motivo y no hay uuid confirmado) */}
      <div style={{ display: cfdi ? "" : "none" }}>
        <div className="containerCosultCancel">
          <div className="bp-bus1">
            <input
              type="text"
              className="fi"
              onFocus={(e) => {
                e.currentTarget.type = "date";
                e.currentTarget.focus();
              }}
              placeholder="Fecha inicial"
              onChange={(event) => setfi(dayjs(event.target.value))}
            />
          </div>
          <div className="bp-bus2">
            <input
              type="text"
              onFocus={(e) => {
                e.currentTarget.type = "date";
                e.currentTarget.focus();
              }}
              placeholder="Fecha final"
              onChange={(event) => setff(dayjs(event.target.value))}
            />
          </div>
          <div className="bp-bus">
            <button className="button" onClick={handleSubmit} type="button">
              Buscar
            </button>
          </div>
        </div>

        {/* <MODAL_TABLE modalGeneral={isLoding} modalT={isLoding} message={mj} /> */}

        <MATERIAL_TABLE_CONTAINER
          columns={columns}
          data={data}
          modalT={isLoding}
          isLoading={isLoding}
          maxHeightTable="30vh"
          search_filters={
            <SEARCH_FILTERS
              setff={setff}
              setfi={setfi}
              setTypeDoc={setTypeDoc}
              fi={fi}
              ff={ff}
              typeDoc={typeDoc}
              handle_get_invoice={handleSubmit}
            />
          }
          component_header={<div />}
          file_name_export="FACTURAS"
          update_identifiers={[]}
        />
      </div>

      {/* Zona inferior de acciones */}
      <div
        className="contanerBtnRelacionar"
        style={{ display: uuidRelation !== "" ? "" : "none" }}
      >
        {/* Confirmación inline (reemplaza Confirm) */}
        <div className="bp-4">
          <Button
            onClick={handleConfirmRelacion}
            sx={{ m: 2, width: "100%" }}
            variant="contained"
            style={{ background: "green" }}
            disabled={!uuidRelation || !select_m}
          >
            Relacionar
          </Button>
        </div>

        <div className="bp-5">
          <Button
            onClick={props.onClose}
            sx={{ m: 2, width: "100%" }}
            variant="contained"
            style={{ background: "red" }}
          >
            Salir
          </Button>
        </div>
      </div>
    </div>
  );
};

export default JOIN_INVOICE;
